import React, { useContext } from "react";
import hexToRgba from "hex-rgba";
import ProgressBar from "core/ProgressBar";
import UnitTypeThemeContext from "../../core/ThemeContext";
import { useSelector } from "react-redux";
import { getExecutionProgress } from "student-front-commons/src/selectors/execution";
import { isNil } from "lodash";

function MasteryTestExecutionProgressBar() {
  const themeContext = useContext(UnitTypeThemeContext);
  const percentage = useSelector(getExecutionProgress);

  if (isNil(percentage)) {
    return null;
  }

  return (
    <ProgressBar
      value={percentage}
      total={1}
      contentColor={themeContext.primary}
      backgroundColor={hexToRgba(themeContext.primary, 20)}
    />
  );
}

export default MasteryTestExecutionProgressBar;
